import CognitiveSR from 'libs/shared/ui/src/lib/components/my-evolution/cognitive/cognitive'
export const Cognitive = () => {
  return (
    <div className="mt-10 w-full">
      <CognitiveSR />
    </div>
  )
}
